export interface PlusgradeResponse {
  responseStatus: PlusgradeResponseStatus;
  url: string;
  urlType: PlusgradeUrlType;
}

export enum PlusgradeUrlType {
  NONE,
  OFFER,
  MODIFY,
  TRACKING,
}

export enum PlusgradeResponseStatus {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  ELIGIBLE = 'ELIGIBLE',
  PNR_NOT_FOUND = 'PNR_NOT_FOUND',
}
